import Dashboard from "~/shared/Dashboard";
import Page from "~/shared/Page";
import ManageAccount from "./ManageAccount";
import UploadDocuments from "./UploadDocuments";
import ManageCertifications from "./ManageCertifications";
import ManageAvailability from "./ManageAvailability";

export default function StaffDashboard() {
    const sections = [
        { title: "Manage Account", path: "manage-account", component: ManageAccount, description: "View & edit your account information.", large: true },
        { title: "Manage Availability", path: "manage-availability", component: ManageAvailability, description: "View & edit your availability." },
        { title: "Manage Certifications", path: "manage-certifications", component: ManageCertifications, description: "View & edit your certifications." },
        { title: "Upload Documents", path: "upload-documents", component: UploadDocuments, description: "Securely upload forms & documents." },
    ];

    const currentSection = Dashboard.useCurrentSection("/staff", sections);

    return (
        <Page title="Staff Dashboard" documentTitle={currentSection?.title ?? "Staff Dashboard"} className="staff-bg">
            <div className="scrolling-container">
                <Dashboard root="/staff" sections={sections} columnSize="300px" />
            </div>
        </Page>
    );
}